import React from 'react';
import PropTypes from 'prop-types';

class AccordionDark extends React.Component {
  constructor() {
    super();
    this.state = {
      open: -1
      // props.children && props.children.length > 1
      //   ? props.children.filter(child => {
      //       return child && child.props && child.props['data-active'];
      //     })[0]
      //   : null
    };
  }

  render() {
    const { children } = this.props;
    const { open } = this.state;
    return (
      <div className="accordion-dark">
        {children &&
          children.length > 0 &&
          children.map(child => {
            if (child.length) {
              // eslint-disable-next-line no-param-reassign, prefer-destructuring
              child = child[0];
            }
            const { props } = child;
            if (props) {
              return (
                <details
                  key={props.label}
                  open={open && open.props && open.props.label === props.label}
                >
                  <summary
                    tabIndex={0}
                    role="tab"
                    onKeyPress={e => {
                      e.preventDefault();
                      this.setState({ open: open === child ? -1 : child });
                    }}
                    onClick={e => {
                      e.preventDefault();
                      this.setState({ open: open === child ? -1 : child });
                    }}
                  >
                    <span>{props.label}</span>
                  </summary>
                  {child}
                </details>
              );
            }
            return '';
          })}
      </div>
    );
  }
}
AccordionDark.defaultProps = {
  children: null
};
AccordionDark.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
export default AccordionDark;
